import { usePodcastProvider } from "./PodcastProvider";
import { PodcastIconButton } from "./PodcastIconButton";
//ui
import { Flex, Text } from "@chakra-ui/react";
import { TwitterIcon, DiscordIcon } from "components/icons";

export function PodcastDetails() {
  const { descriptionData } = usePodcastProvider();
  return (
    <Flex width="100%" flexDir="column" mr="30px">
      <Text
        as="h5"
        fontWeight={{ base: "600", md: "700" }}
        fontSize={{ base: "40px", md: "56px" }}
        maxWidth="520px"
        width="100%"
        lineHeight={{ base: "48px", md: "72px" }}
        mb={{ base: "27px", md: "24px" }}
      >
        {descriptionData?.title}
      </Text>
      <Text as="p" fontSize="16px" lineHeight="20px" letterSpacing="2px" mb={{ base: "27px", md: "9px" }}>
        {descriptionData?.description}
      </Text>
      <Text as="h5" fontWeight="600" fontSize={{ base: "16px", md: "20px" }} lineHeight={{ base: "22px", md: "21px" }} mb={{ base: "19px", md: "10px" }}>
        {descriptionData?.important_details}
      </Text>
      <Flex color="purple.100">
        <PodcastIconButton name="twitterName" Icon={TwitterIcon} color="purple.100" margin="27px" width="27px" height="22px" label="go-to-my-twitter-page" />
        <PodcastIconButton name="discordName" Icon={DiscordIcon} color="purple.100" margin="27px" width="27px" height="22px" label="go-to-my-discord" />
      </Flex>
    </Flex>
  );
}
